
import { Gift } from "../gift/gift";
import { Registry } from "../registry/registry";



export class StarterRegistry  {
public registryName: string;
public registry: Registry;
public gifts: TemplateGift[];
public country: string;
public image1Url: string;
public image2Url: string;
public image3Url: string;
  public countryFlagImageUrl: string;

}


export class TemplateGift extends Gift {
        isAdded: boolean;
        toBeAdded: boolean;
        addedCount: number;
        tags: string[];
        collection: string[];
        points: number;
        index: number;

        super(){
                
        }
}


// WEBPACK FOOTER //
// ./src/app/templates/starter-registry.ts